import { buildTasksQueryOptions } from '@rtkwlf/c3-api-tasks';

import { tasks as tasksApi } from './client';
import { organizations } from './organizations.store';

const queries = buildTasksQueryOptions({
  tasksApi,
  organizations,
});

export { queries };
